
interface FormDisplayProps {
    formId: string;
    onSubmit?: (submission: any) => void;
    readonly?: boolean;
    initialAnswers?: { [questionId: string]: string | string[] };
}

export default function FormDisplay({ formId }: FormDisplayProps) {
    return (
        <div className="max-w-2xl mx-auto p-6 text-center">
            <div className="text-6xl mb-4">📋</div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">Form System Updated</h2>
            <p className="text-gray-600 mb-4">
                This form link is no longer valid. Our form system has been updated and integrated with contact lists.
            </p>
            <div className="bg-blue-50 border border-blue-200 rounded p-4 text-left">
                <h3 className="text-blue-800 font-medium mb-2">What happened?</h3>
                <p className="text-blue-700 text-sm mb-3">
                    We've moved all forms to our new contact list system for better organization and management.
                </p>
                <p className="text-blue-700 text-sm">
                    <strong>Form ID:</strong> {formId}
                </p>
            </div>
            <div className="mt-6">
                <button
                    onClick={() => window.location.href = '/'}
                    className="px-6 py-2 bg-primary40 text-white rounded hover:bg-[#00796b] dark:bg-nightAccent dark:text-[#080808] dark:hover:bg-nightAccent/90"
                >
                    Go to Homepage
                </button>
            </div>
        </div>
    );
}
